import {
    Pagination,
    PaginationContent,
    PaginationEllipsis,
    PaginationItem,
    PaginationLink,
    PaginationNext,
    PaginationPrevious,
} from '@codes/ui-kit/components/ui/pagination';

export interface MarketplacePaginationProps {
    currentPage: number;
    totalPages: number;
    totalCount: number;
    limit: number;
    paginationRange: (number | string)[];
    onPageChange: (page: number) => void;
}

export const MarketplacePagination = ({
    currentPage,
    totalPages,
    totalCount,
    limit,
    paginationRange,
    onPageChange,
}: MarketplacePaginationProps) => {
    if (totalCount === 0) {
        return null;
    }

    return (
        <Pagination className="mt-auto">
            <PaginationContent>
                <PaginationItem>
                    <PaginationPrevious
                        onClick={() => onPageChange(currentPage - 1)}
                        aria-disabled={currentPage <= 0}
                        tabIndex={currentPage <= 0 ? -1 : undefined}
                        className={currentPage <= 0 ? 'pointer-events-none opacity-50' : 'cursor-pointer'}
                    />
                </PaginationItem>
                {paginationRange?.map((pageNumber, index) => (
                    <PaginationItem key={index}>
                        {pageNumber === '...' ? (
                            <PaginationEllipsis />
                        ) : (
                            <PaginationLink
                                className="cursor-pointer"
                                onClick={() => onPageChange(Number(pageNumber))}
                                isActive={currentPage === Number(pageNumber)}
                            >
                                {Number(pageNumber) + 1}
                            </PaginationLink>
                        )}
                    </PaginationItem>
                ))}
                <PaginationItem>
                    <PaginationNext
                        onClick={() => onPageChange(currentPage + 1)}
                        disabled={currentPage === totalPages - 1}
                        aria-disabled={currentPage === totalPages - 1}
                        className={currentPage === totalPages - 1 ? 'pointer-events-none opacity-50' : 'cursor-pointer'}
                    />
                </PaginationItem>
            </PaginationContent>
        </Pagination>
    );
};
